import React from 'react';

export interface BadgeProps {
  children: React.ReactNode;
  tone?: 'neutral' | 'accent' | 'success' | 'warning' | 'danger';
  dot?: boolean;
  style?: React.CSSProperties;
}

const tones = {
  neutral: { bg: 'var(--bg-surface-hover)', fg: 'var(--text-secondary)', dot: 'var(--text-tertiary)' },
  accent: { bg: 'var(--accent-soft)', fg: 'var(--accent)', dot: 'var(--accent)' },
  success: { bg: 'var(--success-tint)', fg: 'var(--success)', dot: 'var(--success)' },
  warning: { bg: 'var(--warning-tint)', fg: 'var(--warning)', dot: 'var(--warning)' },
  danger: { bg: 'var(--danger-tint)', fg: 'var(--danger)', dot: 'var(--danger)' },
};

export function Badge({ children, tone = 'neutral', dot = false, style }: BadgeProps) {
  const t = tones[tone] || tones.neutral;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '3px 10px',
        background: t.bg,
        color: t.fg,
        fontFamily: 'var(--font-body)',
        fontSize: 'var(--text-xs)',
        fontWeight: 'var(--fw-medium)',
        borderRadius: 'var(--radius-full)',
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: t.dot,
            flexShrink: 0,
          }}
        />
      )}
      {children}
    </span>
  );
}
